
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Alkohol lässt einen zwar schneller einschlafen, dafür wacht man später öfter auf. Der Genuss von Wein oder Bier führt nicht nur zu einer Entspannung der Psyche, sondern wirkt sich auch auf die Muskulatur des Körpers aus. Nicht nur die Beine und die Augen werden schwerer, auch die Muskeln tief im Rachen am Zungengrund oder am Gaumensegel lockern sich. Und hier zeigt sich das Problem: Was entspannt ist, kann gut im Luftstrom vibrieren. Sprich: je lockerer die Muskeln im Rachen, desto geräuschvoller das Schnarchen. Das ist so ausgeprägt, dass im alkoholisierten Zustand fast jeder schnarcht! `}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;